import { ReactNode } from 'react';

interface SubscriptionLayoutProps {
  children: ReactNode;
  requiredFeature: string;
}

export const SubscriptionLayout = ({ children }: SubscriptionLayoutProps) => {
  // Legacy subscription-plan-based feature gating kept commented for reference.
  // interface FeatureObject {
  //   featureType: string;
  //   enabled: boolean;
  // }
  //
  // const navigate = useNavigate();
  // const location = useLocation();
  // const currentSubscription = useSubscriptionDetailsStore((state) => state.subscription);
  // const subscriptionPlans = useSubscriptionPlansStore((state) => state.subscriptionPlans);
  // const currentSubscriptionPlan = subscriptionPlans.find((plan) => plan.planId === currentSubscription?.plans?.[0]?.licenceReferenceID) || {
  //   planFeatures: [],
  // };
  // const accessibleFeatures: FeatureObject[] = currentSubscriptionPlan?.planFeatures || [];
  //
  // useEffect(() => {
  //   const hasFeature = accessibleFeatures.some((feature) => feature.featureType === requiredFeature && feature.enabled);
  //   const hasAccess = !requiredFeature || hasFeature;
  //
  //   if (!hasAccess) {
  //     navigate('/403');
  //   }
  // }, [requiredFeature, accessibleFeatures, location.pathname, navigate]);

  return <>{children}</>;
};
